import { PriceList } from '@acme/b2b/pricing';
import { ThemesData } from '@b2b/common/resolvers';
import { ApiService } from '@b2b/common/services/api/types';
import { CalendarService } from '@b2b/common/services/calendar';
import { ThemesHelperService } from '@b2b/common/services/themesHelper';
import { ACMEResponse, Timestamp, TODO, UIBModalService } from '@b2b/types/core';
import { StateService } from '@uirouter/angularjs';
import angular, { IScope, ITimeoutService } from 'angular';
import { ProgramsCombosCreateConfigureAddModalControllerModule } from './ProgramsCombosCreateConfigureAddModalController';
import { isValidBasePrice } from '@acme/b2b/pricing';
import { SelectedAddon, PriceSplitOptions, AddOnQuantityOptions, Addon } from './types'
import { currencyFloatToInteger, integerToCurrencyFloat } from '@acme/b2b/pricing';


ProgramsCombosCreateConfigureController.$inject = [
  '$scope',
  '$state',
  '$uibModal',
  '$timeout',
  'ApiService',
  'CalendarService',
  'HelpersService',
  'ThemesHelperService',
  'ThemesData',
  'EventTemplatesData',
  'AddonsData',
];

function ProgramsCombosCreateConfigureController(
  $scope: IScope & { programsCombosCreateConfigure: TODO },
  $state: StateService,
  $uibModal: UIBModalService,
  $timeout: ITimeoutService,
  ApiService: ApiService,
  CalendarService: CalendarService,
  HelpersService: TODO,
  ThemesHelperService: ThemesHelperService,
  ThemesData: { data: ACMEResponse<ThemesData> },
  EventTemplatesData: TODO,
  AddonsData: TODO
) {
  const ctrl = {
    enableSalesTax: false,
    isSubmitted: false,

    selectedAddon: '',
    selectedTemplate: '',
    selectedDiscount: '' as TODO,
    selectedComboType: 'fixedPrice' as 'fixedPrice' | 'discountCode',
    selectedAddons: [] as SelectedAddon[],
    selectedTemplates: [] as TODO[],
    selectedTemplatesPercent: [] as TODO[],
    selectedTemplateSchedules: [] as TODO[],
    selectedTemplatesQuantity: [] as TODO[],

    selectedSchedule: [] as TODO[],
    selectedPriceList: null as PriceList | null,

    addons: [] as TODO[],
    discounts: [] as TODO[],
    templates: [] as TODO[],
    comboAddons: [] as TODO[],
    comboTemplates: [] as TODO[],
    comboAnyTemplates: [] as TODO[],

    combo: null as Partial<{
      id: string;
      discountId: string | null;
      startTime: Timestamp;
      endTime: Timestamp;
      type: 'fixedPrice' | 'discountCode';
      salesChannels: { channel: string; enabled: boolean }[];
      discountDistributionType: string;
      priceList: PriceList | null;
      addOns: TODO[];
      templates: { entries: TODO[] };
    }> | null,
    selectedTemplatesTotalPercent: '0%',
    selectedDiscountPriceSplit: {} as TODO,

    addOnQuantityOptions: [
      { name: 'Any amount', type: 'any' },
      { name: 'Exactly', type: 'exactly' },
    ] as AddOnQuantityOptions[],

    priceSplitOptions: [
      { name: 'Each', type: 'each' },
      { name: 'Total', type: 'total' },
    ] as PriceSplitOptions[],

    model: {
      salesChannels: [
        { name: 'online', enabled: true },
        { name: 'pos', enabled: true },
        { name: 'reseller', enabled: true },
      ],
    },

    isRemoving: false,
    next: null as TODO | null,

    init: function () {
      let titleLabel = 'Create Combo Details';

      $scope.$on('ProgramsCombosCreateController::save', ctrl.onSave);

      if (ThemesData && ThemesData.data.success) {
        ThemesHelperService.setModel(ThemesData.data.payload);

        ctrl.enableSalesTax = ThemesHelperService.getFeatureFlag('enableSalesTax');
      }

      if (EventTemplatesData && EventTemplatesData.data.success) {
        ctrl.success.initTemplates(EventTemplatesData);
      } else {
        ctrl.error.initTemplates(EventTemplatesData);
      }

      if (AddonsData && AddonsData.data.success) {
        ctrl.success.initAddons(AddonsData);
      } else {
        ctrl.error.initAddons(AddonsData);
      }

      if ($state.params && $state.params.comboId) {
        ctrl.getCombo($state.params.comboId);
        titleLabel = 'Edit Combo Details';
      } else {
        ctrl.initCombos();
      }

      const title = {
        title: titleLabel,
        buttonLeft: {
          label: 'Cancel',
          action: () => {
            $state.go('application.programs.combos.list');
          },
        },
        buttonRight: {
          label: 'Save & Close',
          action: () => {
            ctrl.complete(true);
          },
        },
      };

      ctrl.initDiscounts();
      $scope.$emit('Application::contentTitleChange', title);
    },

    initCombos: function () {
      ctrl.addComboAddon();
      ctrl.addComboTemplate();
    },

    initDiscounts: function () {
      ApiService.discounts
        .list('v2', HelpersService.getPaginator())
        .then((response) => ctrl.success.initDiscounts(response))
        .catch((response) => ctrl.error.initDiscounts(response));
    },

    onSave: function (e, data) {
      ctrl.next = data.state;
      ctrl.complete();
    },

    complete: function (close?: boolean) {
      const errorHandler = close ? ctrl.error.saveAndClose : ctrl.error.complete;
      const successHandler = close ? ctrl.success.saveAndClose : ctrl.success.complete;

      $scope.$emit('ProgramsCombosCreateController::reset');
      ctrl.isSubmitted = true;

      if (ctrl.isValid()) {
        if (ctrl.combo?.id) {
          ApiService.combo.templates
            .update(ctrl.marshal.toJSON())
            .then((response) => successHandler(response))
            .catch((response) => errorHandler(response));
        } else {
          ApiService.combo.templates
            .create(ctrl.marshal.toJSON())
            .then((response) => successHandler(response))
            .catch((response) => errorHandler(response));
        }
      } else {
        $scope.$emit('ProgramsCombosCreateController::error', { message: 'Please correct the errors below.' });
      }
    },

    getCombo: function (id) {
      ApiService.combo.templates
        .get(id)
        .then((response) => ctrl.success.getCombo(response))
        .catch((response) => ctrl.error.getCombo(response));
    },

    getScheduleIndex: function (templateIndex, scheduleId) {
      if (scheduleId) {
        const scheduleMax = ctrl.selectedTemplateSchedules[templateIndex].length;

        for (let scheduleIndex = 0; scheduleIndex < scheduleMax; scheduleIndex++) {
          if (ctrl.selectedTemplateSchedules[templateIndex][scheduleIndex].id === scheduleId) {
            return scheduleIndex;
          }
        }
      }

      return 0;
    },

    getTemplate: function (id: number, templateIndex?: number, scheduleId?: TODO) {
      ApiService.program
        .get(id)
        .then((response) => {
          if (templateIndex != null) {
            ctrl.selectedTemplates[templateIndex].template = angular.copy(response.data.payload);
            ctrl.selectedTemplates[templateIndex].template.schedules.unshift({ name: 'All schedules' });
            ctrl.selectedTemplateSchedules[templateIndex] =
              ctrl.selectedTemplates[templateIndex].template.schedules.slice(0);

            ctrl.selectedSchedule[templateIndex] =
              ctrl.selectedTemplateSchedules[templateIndex][ctrl.getScheduleIndex(templateIndex, scheduleId)];

            ctrl.selectedTemplatesQuantity[templateIndex] = ctrl.selectedTemplatesQuantity[templateIndex] || 1;
            ctrl.selectedTemplatesPercent[templateIndex] = ctrl.selectedTemplatesPercent[templateIndex] || '100%';
          }

          ctrl.calculateTotalPercent();
          ctrl.success.getTemplate(response);
        })
        .catch((response) => ctrl.error.getTemplate(response));
    },

    hasComboTemplates: function () {
      return ctrl.comboTemplates.length > 0;
    },

    hasSelectedTemplates: function () {
      let r = false;

      // Verify there is at least 1 valid event template
      if (Array.isArray(ctrl.selectedTemplates)) {
        for (let i = 0, ii = ctrl.selectedTemplates.length; i < ii; i++) {
          if (ctrl.selectedTemplates[i]) {
            r = true;
            break;
          }
        }
      }

      return r;
    },

    hasComboAddons: function () {
      return ctrl.comboAddons.length > 0;
    },

    hasSelectedAddons: function () {
      let r = false;
      // Verify there is at least 1 valid addon
      if (Array.isArray(ctrl.selectedAddons)) {
        for (let i = 0, ii = ctrl.selectedAddons.length; i < ii; i++) {
          if (ctrl.selectedAddons[i].addon) {
            r = true;
            break;
          }
        }
      }

      return r;
    },

    hasDiscounts: function () {
      return ctrl.discounts.length > 0;
    },

    isComboType: function (type, combo) {
      return combo.type === type;
    },

    hasAddonsWithTemplates: function () {
      if (ctrl.isSubmitted && ctrl.hasSelectedAddons()) {
        return ctrl.hasSelectedTemplates();
      }

      return true;
    },

    hasValidAddons: function () {

      if (ctrl.isSubmitted && ctrl.hasSelectedAddons()) {
        return ctrl.hasValidAddonsBasePrice();
      }

      return true;
    },

    hasValidAddonsBasePrice: function () {
      return ctrl.selectedAddons.every((selectedAddon) => !selectedAddon.hasBasePriceError);
    },

    isValidTotalPercent: function () {
      if (ctrl.isSubmitted && ctrl.showAllocation()) {
        return parseFloat(ctrl.selectedTemplatesTotalPercent) === 100;
      }

      return true;
    },

    isValidPricing: function () {
      if (ctrl.isSubmitted) {
        if (ctrl.selectedComboType === 'fixedPrice') {
          return !!ctrl.selectedPriceList?.id;
        }

        if (ctrl.selectedComboType === 'discountCode') {
          return !!ctrl.selectedDiscount?.id;
        }
      }

      return true;
    },

    isValid: function () {
      return ctrl.isValidTotalPercent() && ctrl.isValidPricing() && ctrl.hasAddonsWithTemplates() && ctrl.hasValidAddons();
    },

    findEventTemplate: function (id: string): object | undefined {
      return ctrl.templates.find((item) => item.id === id);
    },

    findDiscount: function (id: string) {
      for (let i = 0, ii = ctrl.discounts.length; i < ii; i++) {
        if (ctrl.discounts[i].id === id) {
          return {
            index: i,
            discount: ctrl.discounts[i],
          };
        }
      }

      return undefined;
    },

    findPriceSplit: function (type: string) {
      for (let i = 0, ii = ctrl.priceSplitOptions.length; i < ii; i++) {
        if (ctrl.priceSplitOptions[i].type === type) {
          return {
            index: i,
            priceSplit: ctrl.priceSplitOptions[i],
          };
        }
      }

      return undefined;
    },

    showAddModal: function (templateIndex: number) {
      const selectedTemplatesList = ctrl.comboAnyTemplates[templateIndex];

      $uibModal
        .open<TODO>({
          templateUrl: 'views/application/views/programs/combos/create/configure/modals/addComboEvent.tpl.html',
          size: 'md',
          controller: 'ProgramsCombosCreateConfigureAddModalController',
          resolve: {
            templatesList: () => ctrl.templates.slice(1),
            selectedTemplatesList: () => selectedTemplatesList,
          },
        })
        .result.then((selectedTemplates) => {
          $scope.$emit('ProgramsCombosCreateController::reset');
          ctrl.isRemoving = true;
          ctrl.addSelectedTemplates(templateIndex, selectedTemplates);
        })
        .catch(() => {
          // noop
        });
    },

    addSelectedTemplates: function (templateIndex: number, selectedTemplates: Record<string, boolean>) {
      const comboAnyTemplates: TODO[] = [];

      for (const id in selectedTemplates) {
        if (selectedTemplates[id] === true) {
          const template = ctrl.findEventTemplate(id);

          if (template != null) {
            comboAnyTemplates.push(template);
          }
        }
      }

      ctrl.comboAnyTemplates[templateIndex] = comboAnyTemplates;
    },

    addComboAddon: function (addon?: Addon) {
      const combo: TODO = { type: 'addon' };
      let price: string | number = 0;
      let basePrice: string | number | null = 0;

      if (addon) {
        combo.addon = addon;
        price = addon.price;
        basePrice = addon.basePrice;
      } else {
        combo.type = 'new';
      }

      ctrl.comboAddons.push(combo);
      ctrl.selectedAddons.push({
        addon: addon,
        quantity: 1,
        quantityType: ctrl.addOnQuantityOptions[0],
        price: price,
        basePrice: basePrice,
        priceSplit: ctrl.priceSplitOptions[0],
        hasBasePriceError: false,
      });
    },

    removeComboAddon: function (index) {
      ctrl.selectedAddons.splice(index, 1);
      ctrl.comboAddons.splice(index, 1);
    },

    addComboTemplate: function (type?: string, event?: TODO) {
      let combo: TODO = { type: type };

      if (type === 'any') {
        combo.quantity = 1;
        combo.events = [];
      } else if (type === 'event') {
        combo.event = event;
      } else {
        combo = { type: 'new' };
      }

      ctrl.comboTemplates.push(combo);

      return combo;
    },

    removeComboTemplate: function (index) {
      ctrl.selectedTemplates.splice(index, 1);
      ctrl.selectedSchedule.splice(index, 1);
      ctrl.selectedTemplateSchedules.splice(index, 1);
      ctrl.selectedTemplatesPercent.splice(index, 1);
      ctrl.selectedTemplatesQuantity.splice(index, 1);
      ctrl.comboAnyTemplates.splice(index, ctrl.comboAnyTemplates.length);
      ctrl.comboTemplates.splice(index, 1);
      ctrl.calculateTotalPercent();
    },

    addComboAnyTemplate: function (comboItemIndex) {
      ctrl.comboAnyTemplates[comboItemIndex].push({ name: false });
    },

    removeComboAnyTemplate: function (comboItemIndex, index) {
      ctrl.comboAnyTemplates[comboItemIndex].splice(index, 1);
    },

    updateComboAddon: function (combo?: TODO, addon?: TODO, addonIndex?: TODO) {
      const selected = ctrl.selectedAddons[addonIndex];

      $timeout(() => {
        if (!selected) {
          // Nothing selected
          combo.type = 'new';
        } else {
          combo.type = 'addon';
        }
      }, 10);
    },

    convertToPercent: function (index: number) {
      const value = parseFloat(ctrl.selectedTemplatesPercent[index]);

      ctrl.selectedTemplatesPercent[index] = `${isNaN(value) ? 0 : value}%`;
      ctrl.calculateTotalPercent();
    },

    convertAddOnPriceToCurrency: function (index) {
      const addon = ctrl.selectedAddons[index]?.addon;
      if (!addon) {
        return;
      }

      const addonPrice = addon.price;
      if (addonPrice === '' || addonPrice === null || addonPrice === undefined) {
        return;
      }

      const price = currencyFloatToInteger(addonPrice);
      addon.price = integerToCurrencyFloat(price, { significant: 2, enforceFixed: true });
    },

    convertAddOnBasePriceToCurrency: function (index) {
      const addon = ctrl.selectedAddons[index]?.addon;
      if (!addon) {
        return;
      }

      const basePrice = addon.basePrice;
      if (basePrice === '' || basePrice === null || basePrice === undefined) {
        addon.basePrice = null;
        return;
      }

      const price = currencyFloatToInteger(basePrice);
      addon.basePrice = integerToCurrencyFloat(price, { significant: 2, enforceFixed: true });
      ctrl.validateBasePrice(index);
    },

    validateBasePrice: function (index: number) {
      if (ctrl.enableSalesTax === false) {
        ctrl.selectedAddons[index].hasBasePriceError = false;
        return;  
      }

      if (!ctrl.selectedAddons[index] || !ctrl.selectedAddons[index].addon) {
        return
      }

      const isValid = isValidBasePrice({
        price: String(ctrl.selectedAddons[index].addon.price),
        basePrice: String(ctrl.selectedAddons[index].addon.basePrice)
      });

      ctrl.selectedAddons[index].hasBasePriceError = !isValid;
    },

    calculateTotalPercent: function () {
      let total = 0;
      let percent = 0;

      for (let i = 0, ii = ctrl.selectedTemplatesPercent.length; i < ii; i++) {
        // Make sure we have a selected template
        if (ctrl.selectedTemplates[i]) {
          percent = parseFloat(ctrl.selectedTemplatesPercent[i]);
          if (!isNaN(percent)) {
            total += percent;
          }
        }
      }

      ctrl.selectedTemplatesTotalPercent = total + '%';
    },

    updateComboTemplate: function (combo: TODO, templateIndex?: number, scheduleId?: TODO) {
      const template = templateIndex != null ? ctrl.selectedTemplates[templateIndex] : null;

      // Wait for on change event to propagate to models
      $timeout(() => {
        if (templateIndex != null && !template) {
          // Nothing selected
          combo.type = 'new';
          ctrl.selectedTemplatesPercent[templateIndex] = ctrl.selectedTemplatesPercent[templateIndex] || '0%';
          ctrl.calculateTotalPercent();
        } else {
          if (template.name === 'Any') {
            // Any event selected
            combo.type = 'any';
            if (templateIndex != null && !Array.isArray(ctrl.comboAnyTemplates[templateIndex])) {
              ctrl.comboAnyTemplates[templateIndex] = [];
              ctrl.comboAnyTemplates[templateIndex].push({ name: false });
              ctrl.selectedTemplatesQuantity[templateIndex] = ctrl.selectedTemplatesQuantity[templateIndex] || 1;
              ctrl.selectedTemplatesPercent[templateIndex] = ctrl.selectedTemplatesPercent[templateIndex] || '100%';
              ctrl.calculateTotalPercent();
            }
          } else {
            combo.type = 'event';
            ctrl.getTemplate(template.id, templateIndex, scheduleId);
          }
        }
      }, 10);
    },

    allowComboAdd: function (index) {
      return ctrl.comboTemplates.length - 1 === index;
    },

    allowComboRemove: function () {
      return ctrl.comboTemplates.length > 1;
    },

    allowAddonAdd: function (index) {
      return ctrl.comboAddons.length - 1 === index;
    },

    allowAddonRemove: function () {
      return ctrl.comboAddons.length > 1;
    },

    allowComboAnyAdd: function (comboItemIndex, index) {
      return ctrl.comboAnyTemplates[comboItemIndex].length - 1 === index;
    },

    allowComboAnyRemove: function (comboItemIndex) {
      return ctrl.comboAnyTemplates[comboItemIndex].length > 1;
    },

    showAllocation: function () {
      return ctrl.selectedComboType === 'fixedPrice' || ctrl.selectedDiscountPriceSplit.type === 'total';
    },

    setAddonPriceSplit: function (index) {
      if (ctrl.selectedAddons[index].quantityType.type === 'any') {
        ctrl.selectedAddons[index].priceSplit = ctrl.priceSplitOptions[0];
      }
    },

    getQuantityType: function (quantityType) {
      for (let i = 0; i < ctrl.addOnQuantityOptions.length; i++) {
        if (ctrl.addOnQuantityOptions[i].type === quantityType) {
          return ctrl.addOnQuantityOptions[i];
        }
      }

      return ctrl.addOnQuantityOptions[0];
    },

    getPriceSplit: function (priceSplit) {
      for (let i = 0; i < ctrl.priceSplitOptions.length; i++) {
        if (ctrl.priceSplitOptions[i].type === priceSplit) {
          return ctrl.priceSplitOptions[i];
        }
      }

      return ctrl.priceSplitOptions[0];
    },

    getTemplateById: function (templateId) {
      if (ctrl.templates) {
        for (let i = 0; i < ctrl.templates.length; i++) {
          if (ctrl.templates[i].id === templateId) {
            return ctrl.templates[i];
          }
        }
      }

      return null;
    },

    onSelectedPriceListChange: function (event: { priceList: PriceList | null }) {
      ctrl.selectedPriceList = event.priceList;
    },

    success: {
      init: function (response) {},

      initAddons: function (response) {
        ctrl.addons = response.data.payload.list;
      },

      initTemplates: function (response) {
        const templates = [{ name: 'Any' }];
        ctrl.templates = templates.concat(response.data.payload.list);
      },

      initDiscounts: function (response) {
        ctrl.discounts = response.data.payload.list;

        if (ctrl.combo && ctrl.combo.discountId) {
          const found = ctrl.findDiscount(ctrl.combo.discountId);

          if (found) {
            ctrl.selectedDiscount = ctrl.discounts[found.index];
          }
        }
      },

      getTemplate: function (response) {
        // Handled inline
      },

      getCombo: function (response) {
        ctrl.marshal.fromJSON(response.data.payload);
      },

      complete: function (response) {
        ctrl.isSubmitted = false;

        if (ctrl.next) {
          $state.go(ctrl.next, { comboId: response.data.payload.id });
        }
      },

      saveAndClose: function (response) {
        ctrl.isSubmitted = false;

        $scope.$emit('ProgramsCombosCreateController::success', { message: 'Successfully Saved!' });
        $scope.$emit('ProgramsCombosCreateController::transition', { state: 'application.programs.combos.list' });
      },
    },

    error: {
      init: function (response) {},
      initAddons: function (response) {},
      initTemplates: function (response) {},
      initDiscounts: function (response) {},
      getTemplate: function (response) {},
      getCombo: function (response) {},
      complete: function (response) {
        $scope.$emit('ProgramsCombosCreateController::error', { message: response.data.error });
      },
      saveAndClose: function (response) {
        $scope.$emit('ProgramsCombosCreateController::error', { message: response.data.error });
      },
    },

    onSelectedAddonUpdate: function (newValue, oldValue) {
      ctrl.updateComboAddon(newValue);
    },

    onSelectedTemplateUpdate: function (newValue, oldValue) {
      ctrl.updateComboTemplate(newValue);
    },

    marshal: {
      toJSON: function () {
        if (ctrl.combo) {
          ctrl.combo.startTime = ctrl.combo.startTime ? CalendarService.toISO8601(ctrl.combo.startTime) : undefined;
          ctrl.combo.endTime = ctrl.combo.endTime ? CalendarService.toISO8601(ctrl.combo.endTime) : undefined;
          ctrl.marshal.salesChannels.toJSON();
          ctrl.marshal.addOns.toJSON();
          ctrl.marshal.templates.toJSON();
          ctrl.combo.type = ctrl.selectedComboType;

          const found = ctrl.findPriceSplit(ctrl.selectedDiscountPriceSplit.type);

          if (found) {
            ctrl.combo.discountDistributionType = found.priceSplit.type;
          }

          if (ctrl.combo.type === 'fixedPrice') {
            ctrl.combo.discountId = null;
            ctrl.combo.priceList = ctrl.selectedPriceList;

            for (const prices of ctrl.combo.priceList?.prices ?? []) {
              prices.basePrice = prices.basePrice === '' ? null : prices.basePrice;
            }
          } else {
            ctrl.combo.discountId = ctrl.selectedDiscount.id;
            ctrl.combo.priceList = null;
          }
        } else {
          ctrl.combo = {
            startTime: CalendarService.toISO8601(new Date()),
            endTime: CalendarService.toISO8601(new Date()),
          };
        }

        return ctrl.combo;
      },

      fromJSON: function (json) {
        ctrl.combo = json;
        ctrl.marshal.salesChannels.fromJSON(json);
        ctrl.marshal.addOns.fromJSON(json);
        ctrl.marshal.templates.fromJSON(json);
        ctrl.selectedComboType = ctrl.combo?.type ?? 'fixedPrice';
        ctrl.selectedPriceList = ctrl.combo?.priceList ?? null;

        if (ctrl.combo?.discountId) {
          const found = ctrl.findDiscount(ctrl.combo.discountId);

          if (found) {
            ctrl.selectedDiscount = ctrl.discounts[found.index];
          }
        }
        if (ctrl.combo?.discountDistributionType) {
          const found = ctrl.findPriceSplit(ctrl.combo.discountDistributionType);

          if (found) {
            ctrl.selectedDiscountPriceSplit = found.priceSplit;
          }
        } else {
          ctrl.selectedDiscountPriceSplit = ctrl.priceSplitOptions[0];
        }
      },

      salesChannels: {
        toJSON: function () {
          if (ctrl.combo == null) {
            return;
          }

          ctrl.combo.salesChannels = [];

          for (let i = 0; i < ctrl.model.salesChannels.length; i++) {
            ctrl.combo?.salesChannels.push({
              channel: ctrl.model.salesChannels[i].name,
              enabled: ctrl.model.salesChannels[i].enabled,
            });
          }
        },

        fromJSON: function (json) {
          if (json.salesChannels) {
            for (let i = 0; i < json.salesChannels.length; i++) {
              const sourceSalesChannelName = json.salesChannels[i].channel;

              for (let ii = 0; ii < ctrl.model.salesChannels.length; ii++) {
                if (ctrl.model.salesChannels[ii].name === sourceSalesChannelName) {
                  ctrl.model.salesChannels[ii].enabled = json.salesChannels[i].enabled;
                }
              }
            }
          }
        },
      },

      addOns: {
        toJSON: function () {
          if (ctrl.combo == null) {
            return;
          }

          ctrl.combo.addOns = [];

          if (ctrl.selectedAddons) {
            for (const selectedAddon of ctrl.selectedAddons) {
              if (selectedAddon.addon) {
                ctrl.combo.addOns.push({
                  id: selectedAddon.addon?.id,
                  quantity: selectedAddon.quantity,
                  price: selectedAddon.addon?.price,
                  basePrice: selectedAddon.addon?.basePrice,
                  quantityType: selectedAddon.quantityType.type,
                  priceSplit: selectedAddon.priceSplit.type,
                });
              }
            }
          }
        },

        fromJSON: function (json) {
          let i;
          let n;
          let addOnIndex;
          let addOnCount;
          let currentAddOn;
          let selectedAddOnIndex = 0;

          if (Array.isArray(json.addOns) && json.addOns.length > 0) {
            n = json.addOns.length;
            addOnCount = ctrl.addons.length;

            for (i = 0; i < n; i++) {
              currentAddOn = json.addOns[i].addOnId;

              for (addOnIndex = 0; addOnIndex < addOnCount; addOnIndex++) {
                if (ctrl.addons[addOnIndex].id === currentAddOn) {
                  ctrl.addComboAddon(ctrl.addons[addOnIndex]);

                  selectedAddOnIndex = ctrl.selectedAddons.length - 1;

                  const selectedAddOn = ctrl.selectedAddons[selectedAddOnIndex];                  
                  
                  selectedAddOn.quantity = json.addOns[i].quantity;
                  selectedAddOn.priceSplit = ctrl.getPriceSplit(json.addOns[i].priceSplit);
                  selectedAddOn.quantityType = ctrl.getQuantityType(json.addOns[i].quantityType);

                  if (selectedAddOn.addon !== undefined) {
                    selectedAddOn.addon.price = json.addOns[i].price;

                    if (ctrl.enableSalesTax && json.addOns[i].basePrice) {
                      selectedAddOn.addon.basePrice = json.addOns[i].basePrice;
                    }
                  }

                  break;
                }
              }
            }
          } else {
            ctrl.addComboAddon();
          }
        },
      },

      templates: {
        fromJSON: function (json) {
          let i;
          let n;
          let currentTemplateId;
          let templateIndex;
          let templateCount;

          if (json.templates && Array.isArray(json.templates.entries) && json.templates.entries.length > 0) {
            n = json.templates.entries.length;
            templateCount = ctrl.templates.length;
            for (i = 0; i < n; i++) {
              if (json.templates.entries[i].type === 'event') {
                const combo = ctrl.addComboTemplate('event');
                currentTemplateId = json.templates.entries[i].templateId;

                for (templateIndex = 0; templateIndex < templateCount; templateIndex++) {
                  if (ctrl.templates[templateIndex].id === currentTemplateId) {
                    ctrl.selectedTemplates[i] = ctrl.templates[templateIndex];
                    ctrl.updateComboTemplate(combo, i, json.templates.entries[i].schedule);
                    break;
                  }
                }
              } else {
                const newList: TODO[] = [];
                let currentSourceTemplateId;

                ctrl.addComboTemplate('any');
                ctrl.selectedTemplates[i] = ctrl.templates[0];
                const maxSourceTemplateIds = json.templates.entries[i].templateIds.length;

                for (
                  currentSourceTemplateId = 0;
                  currentSourceTemplateId < maxSourceTemplateIds;
                  currentSourceTemplateId++
                ) {
                  newList.push(ctrl.getTemplateById(json.templates.entries[i].templateIds[currentSourceTemplateId]));
                }

                if (ctrl.comboAnyTemplates == null) {
                  ctrl.comboAnyTemplates = [];
                }
                ctrl.comboAnyTemplates[i] = newList;
              }

              ctrl.selectedTemplatesPercent[i] = json.templates.entries[i].revenueAllocation;
              ctrl.convertToPercent(i);
              ctrl.selectedTemplatesQuantity[i] = json.templates.entries[i].quantity;
            }
          } else {
            ctrl.addComboTemplate();
          }
        },

        toJSON: function () {
          let i;
          let newEntry;

          if (ctrl.combo == null) {
            ctrl.combo = {};
          }

          ctrl.combo.templates = { entries: [] };

          if (ctrl.comboTemplates) {
            for (i = 0; i < ctrl.comboTemplates.length; i++) {
              if (ctrl.isComboType('any', ctrl.comboTemplates[i])) {
                if (ctrl.comboAnyTemplates && ctrl.comboAnyTemplates.length > i) {
                  const comboArray: TODO[] = [];
                  const currentAny = ctrl.comboAnyTemplates[i];

                  if (currentAny) {
                    for (let comboEntryIndex = 0; comboEntryIndex < currentAny.length; comboEntryIndex++) {
                      comboArray.push(currentAny[comboEntryIndex].id);
                    }

                    newEntry = { templateIds: comboArray };
                  }
                }
              } else {
                newEntry = { templateId: ctrl.selectedTemplates[i].id };
              }

              newEntry['revenueAllocation'] = ctrl.selectedTemplatesPercent[i];
              newEntry['quantity'] = ctrl.selectedTemplatesQuantity[i];
              if (i < ctrl.selectedSchedule.length && ctrl.selectedSchedule[i]) {
                newEntry['schedule'] = ctrl.selectedSchedule[i].id;
              }

              if (ctrl.combo && newEntry) {
                ctrl.combo.templates.entries.push(newEntry);
              }
            }
          }
        },
      },
    },
  };

  $scope.programsCombosCreateConfigure = ctrl;
  ctrl.init();
}

export const ProgramsCombosCreateConfigureControllerModule = angular
  .module('acme.view.application.programs.combos.create.configure.controllers', [
    'ui.router',
    'ui.bootstrap',
    'acme.common.service.api',
    'acme.common.service.calendar',
    'acme.common.service.helpers',
    'acme.common.service.themesHelper',
    ProgramsCombosCreateConfigureAddModalControllerModule,
  ])
  .controller('ProgramsCombosCreateConfigureController', ProgramsCombosCreateConfigureController).name;
